export default {
  namespaced: true,
  state: () => ({
    isShowAlert: false,
    alertInfo: {
      icon: '',
      title: '',
      desc: '',
      buttons: [
        // { key: '', text: '', btnStyle: '', onClick: null },
      ],
      autoClose: false,
    },
    isConfirm: false,
    time: 5000,
    timerId: undefined,
  }),
  mutations: {
    SHOW_ALERT(state) {
      state.isShowAlert = true;
    },
    CLOSE_ALERT(state) {
      state.isShowAlert = false;
    },
    // SET_CONFIRM(state, isConfirm) {
    //   state.isConfirm = isConfirm;
    // },
    RESET_ALERT_INFO(state) {
      state.alertInfo.icon = '';
      state.alertInfo.title = '';
      state.alertInfo.desc = '';
      state.alertInfo.confirm = '';
      state.alertInfo.buttons = [];
      state.alertInfo.autoClose = false;
    },
    SET_ALERT_INFO(state, alertInfo) {
      state.alertInfo = alertInfo;
    },
    SET_AUTO_CLOSE_TIEMR(state, timerId) {
      state.timerId = timerId;
    },
  },
  actions: {
    setAlertInfo({ commit, state, dispatch }, alertInfo) {
      if (alertInfo.autoClose) {
        const timerId = setTimeout(() => {
          dispatch('closeAlert');
        }, state.time);
        commit('SET_AUTO_CLOSE_TIEMR', timerId);
      }
      commit('SET_ALERT_INFO', alertInfo);
      commit('SHOW_ALERT');
    },
    closeAlert({ commit, state }) {
      if (state.timerId) {
        clearTimeout(state.timerId);
      }
      commit('CLOSE_ALERT');
      commit('RESET_ALERT_INFO');
    },
  },
  getters: {
    isShowAlert(state) {
      return state.isShowAlert;
    },
    // isConfirm(state) {
    //   return state.isConfirm;
    // },
    getAlertInfo(state) {
      return state.alertInfo;
    },
  },
};
